import * as React from 'react';

import { FormActionsStore } from 'stores/common/form';

const FormReviewPageContext = React.createContext<{
  route: string;
  setRoute: (route: string) => void;
  store: FormActionsStore | null;
  setStore: (store: FormActionsStore) => void;
  extraHeaderButtons: React.ReactNode;
  setExtraHeaderButtons: (buttons: React.ReactNode) => void;
  formName: string;
  setFormName: (name: string) => void;
} | null>(null);

export const FormReviewPageContextProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const [route, setRoute] = React.useState<string>('');

  const [store, setStore] = React.useState<FormActionsStore | null>(null);

  const [extraHeaderButtons, setExtraHeaderButtons] =
    React.useState<React.ReactNode>(null);

  const [formName, setFormName] = React.useState<string>('');

  const value = React.useMemo(() => {
    return {
      route,
      setRoute,
      store,
      setStore,
      extraHeaderButtons,
      setExtraHeaderButtons,
      formName,
      setFormName,
    };
  }, [route, store, extraHeaderButtons, formName]);

  return (
    <FormReviewPageContext.Provider value={value}>
      {children}
    </FormReviewPageContext.Provider>
  );
};

export const useFormReviewPage = () => {
  const context = React.useContext(FormReviewPageContext);

  if (!context) {
    throw new Error('FormReviewPageContext is required!');
  }

  return context;
};
